exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".MIqgU7VLIpYHgFdSF_mNN {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: flex-start;\n    position: fixed;\n    bottom: 0;\n    left: 0;\n    height: 2.5em;\n    margin-left: 0.5em;\n    margin-bottom: 0.5em;\n    z-index: 5999;\n}\n\n\n", ""]);

// Exports
exports.locals = {
	"container": "MIqgU7VLIpYHgFdSF_mNN"
};